const styles = theme => ({
  root: {},

  content: {
    fontFamily: "'Montserrat', sans-serif",
    fontWeight: 500,
    display: 'flex',
    flexDirection: 'column',
    marginTop: 60,
    paddingLeft: '20%',
    paddingRight: '20%',
    paddingBottom: 50,
    [theme.breakpoints.down('md')]: {
      paddingLeft: '10%',
      paddingRight: '10%'
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: '5%',
      paddingRight: '5%'
    }
  },

  backButton: {
    cursor: 'pointer',
    color: '#122B4F',
    fontFamily: "'Montserrat', sans-serif",
    fontWeight: 'bold',
    position: 'absolute',
    top: 80,
    left: 20
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/containers/faqs/styles.js